<template lang="pug">
  div
    | Show
    .mx-2.d-inline-block
      input.form-control.form-control-sm(type='text' value='8' size='3' :value="value" @input="$emit('input',$event.target.value)")
    | entries
</template>

<script>
export default {
  props: ['value']
}
</script>